import { Grid, Tab, Tabs } from "@mui/material";
import React, { useState } from "react";
import BreakDownReport from "./BreakDownReport";
import StockRoomReport from "./StockRoomReport";
import PartTransactionSummary from "./PartTransactionSummary";

const Reports = () => {
  const [tabValue, setTabValue] = useState(0);

  return (
    <Grid container spacing={"1rem"} padding={"1rem"}>
      <Grid item xs={12}>
        <Tabs
          value={tabValue}
          onChange={(e, newValue) => setTabValue(newValue)}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={{
            "& .MuiTabs-flexContainer": { gap: "2rem" },
            "& .MuiTab-root": { textTransform: "none", minWidth: "auto", px: 0 },
          }}
        >
          <Tab label="Break Down Reports" />
          <Tab label="Stock Room Turn Over Reports" />
          <Tab label="Part Transaction Summary" />
        </Tabs>
      </Grid>

      <Grid item xs={12}>
        {tabValue === 0 && <BreakDownReport />}
        {tabValue === 1 && <StockRoomReport />}
        {tabValue === 2 && <PartTransactionSummary />}
      </Grid>
    </Grid>
  );
};

export default Reports;
